/**
 * eSalon — Growth landing gallery thumbnails (WEB-6534)
 *
 * Drives the Dawn <slider-component> inside sections/esalon-growth-intro.liquid
 * from its thumbnail grid, matching the legacy thumbs-swiper on
 * www.esalon.com/custom-hair-growth. Clicking a thumbnail scrolls the track to
 * that slide; scrolling the track (swipe, keyboard, the mobile arrows) moves
 * aria-current to the matching thumbnail.
 *
 * Markup contract:
 *   <esalon-growth-gallery data-slider="#Slider-XYZ">
 *     <slider-component> <ul id="Slider-XYZ"> <li id="Slide-XYZ-1"> … </ul> …
 *       <button data-gallery-thumb="0"> …
 */
(function () {
  'use strict';

  class EsalonGrowthGallery extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector(this.dataset.slider);
      if (!this.slider) return;
      this.slides = this.slider.querySelectorAll('[id^="Slide-"]');
      this.thumbs = this.querySelectorAll('[data-gallery-thumb]');
      if (!this.thumbs.length) return;

      // Bound once: connectedCallback re-runs when the theme editor re-attaches
      // the section, and the scroll listener is removed on disconnect.
      if (!this._onScroll) this._onScroll = this._handleScroll.bind(this);
      this.slider.addEventListener('scroll', this._onScroll, { passive: true });

      this.thumbs.forEach((thumb) => {
        if (thumb.dataset.galleryBound) return;
        thumb.dataset.galleryBound = 'true';
        thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.galleryThumb)));
      });
    }

    disconnectedCallback() {
      if (this.slider) this.slider.removeEventListener('scroll', this._onScroll);
    }

    goTo(index) {
      const slide = this.slides[index];
      if (!slide) return;
      this.slider.scrollTo({ left: slide.offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth' });
      this._setCurrent(index);
    }

    _handleScroll() {
      const width = this.slides[0] ? this.slides[0].clientWidth : 0;
      if (!width) return;
      this._setCurrent(Math.round(this.slider.scrollLeft / width));
    }

    _setCurrent(index) {
      this.thumbs.forEach((thumb, i) => {
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get('esalon-growth-gallery')) {
    customElements.define('esalon-growth-gallery', EsalonGrowthGallery);
  }
})();
